import React, { useMemo } from 'react'
import lang from '@/lang'
import { makeStyles } from '@mui/styles'

import ThemeInterface from '@/theme-interface'
import RichTooltip from '@/modules/base/components/rich-tooltip/rich-tooltip'
import DocumentContainerOpenedIcon from '@assets/images/icons/folder-opened.svg'
import SVGIcon from '@/modules/base/components/svg-icon/svg-icon'
import config from '@/config'
import { isMeinBuero } from '@/utils/build-env'

const isMB = isMeinBuero()

const useStyles = makeStyles((theme: ThemeInterface) => ({
  documentContainerAction: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    color: theme.primaryDark,
    '&:hover': {
      color: isMB ? theme.primaryLight : theme.primaryBright,
      '& $documentContainerIcon': {
        fill: isMB ? theme.primaryLight : theme.primaryBright,
      },
    },
  },
  documentContainerIcon: {
    fill: theme.primaryDark,
  },
  documentContainerLabel: {
    marginLeft: 5,
    fontWeight: theme.fontWeights.medium,
  },
  tooltip: {
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
    fontFamily: theme.fontFamily,
    fontWeight: theme.fontWeights.regular,
    lineHeight: '1rem',
  },
  tooltipTitle: {
    fontWeight: theme.fontWeights.medium,
  },
  description: {
    fontSize: theme.fontSizes.extrasmall,
  },
  info: {
    fontSize: theme.fontSizes.extrasmall,
  },
}))

interface ReceiptDocumentContainerAction {
  onOpen: () => void
}

const ReceiptDocumentContainerAction = (props) => {
  const classes = useStyles()
  const { onOpen } = props

  const tooltipContent = useMemo(() => {
    return (
      <div className={classes.tooltip}>
        <div className={classes.tooltipTitle}>{lang.receipt.documentContainer.tooltip.title}</div>
        <div className={classes.description}>{lang.receipt.documentContainer.tooltip.description}</div>
        <div className={classes.info}>
          {lang.receipt.documentContainer.tooltip.info}<br />
          <a target='_blank' href={config.productInfoLinks.documentInfoUrl}>{lang.receipt.documentContainer.tooltip.linkLabel}</a>
        </div>
      </div>
    )
  }, [])

  const content = (
    <div className={classes.documentContainerAction} onClick={onOpen}>
      <SVGIcon
        svg={DocumentContainerOpenedIcon}
        height='13px'
        width='13px'
        className={classes.documentContainerIcon} />
      <div className={classes.documentContainerLabel}>{lang.receipt.documentContainer.open}</div>
    </div>
  )

  if (isMB) {
    return content
  }

  return (
    <RichTooltip
      content={tooltipContent}
      placement='bottom'>
      {content}
    </RichTooltip>
  )
}

export default ReceiptDocumentContainerAction
